export default {
  DELETING: 'ADMIN_VIEW_MARKET_SPACES_DELETOR_DELETING',
  DELETED: 'ADMIN_VIEW_MARKET_SPACES_DELETOR_DELETED',
};
